import { Injectable } from '@angular/core';
import { GenericsService } from './generics.service';
import { environment } from '../../environments/environment';
import { FindEssentialEntity } from '../models/filter/find-essential-entity';
import { TokenStorageService } from './token-storage.service';
import { FilterEntity } from '../models/filter/filter-entity';
import { FindEntity } from '../models/filter/find-entity';
import { CODE_SITE_CENTRALE } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class FindEssentialService {
  codeSite = CODE_SITE_CENTRALE;

  constructor(
    public genericsService: GenericsService,
    private tokenStorage: TokenStorageService
  ) { }

  public getBilletage() {
    const filter = new FilterEntity('N_Devise', 'ENTIER', null, '=', '1');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_BILLETPIECE', [filter], this.tokenStorage.getCurrentSite(),
        'cbMarq', 'BI_Intitule', 'BI_Valeur')
    );
  }
  public getDepotsDefauts(columnDepot) {

    const filter = new FilterEntity('code', 'CHAINE', null, 'LIKE', this.tokenStorage.getCodeSite());
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('SYS_SITE', [filter], this.tokenStorage.getCurrentSite(),
        'id', 'name', columnDepot)
    );
  }
  public getSites(token?) {
    if (token) {
      const filter = new FilterEntity('code', 'CHAINE', null, 'LIKE', token);
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('SYS_SITE', [filter], this.tokenStorage.getCurrentSite(),
          'id', 'name', 'code')
      );
    } else {
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('SYS_SITE', [], this.tokenStorage.getCurrentSite(),
          'id', 'name', 'code')
      );
    }
  }
  public getTypeDoc(token?) {
    if (token) {
      const filter = new FilterEntity('code', 'CHAINE', null, 'LIKE', token);
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('v_dtc_type_doc', [filter], this.tokenStorage.getCurrentSite(),
          'id', 'libelle', 'data_type')
      );
    } else {
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('v_dtc_type_doc', [], this.tokenStorage.getCurrentSite(),
          'id', 'libelle', 'data_type')
      );
    }
  }
  public getSitesByIdForTransfertState(id) {
    const filter = new FilterEntity('id', 'ENTIER', null, '=', id);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('SYS_SITE', [filter], this.tokenStorage.getCurrentSite(),
        'id_etat_imprimable_annulation', 'id_etat_imprimable_src', 'id_etat_imprimable_dst', 'id_etat_imprimable_transfert')
    );
  }
  public getSitesByIdForTransfertCommandeState(id) {
    const filter = new FilterEntity('id', 'ENTIER', null, '=', id);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('SYS_SITE', [filter], this.tokenStorage.getCurrentSite(),
        'id_etat_imprimable_src', 'id_etat_imprimable_transfert')
    );
  }

  public getSitesByIdForTransfertStateBDC(id) {
    const filter = new FilterEntity('id', 'ENTIER', null, '=', id);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('SYS_SITE', [filter], this.tokenStorage.getCurrentSite(),
        'id_etat_imprimable_annulation', 'id_etat_imprimable_src', 'id_etat_imprimable_bdc')
    );
  }
  public getCompteGeneraux(action?: string) {
    let filter;
    if (action === 'detail') {
      filter = [new FilterEntity('CG_Type', 'ENTIER', null, '=', '0')];
    } else {
      filter = []
    }
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COMPTEG', filter, this.tokenStorage.getCurrentSite(),
        'CG_Num', 'CG_Classement', 'CG_Intitule')
    );
  }
  public getLit() {
    // const filter = new FilterEntity('CG_Type', 'ENTIER', null, '=', value);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('APP_HOS_LIT', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle', 'description')
    );
  }

  public getSalle() {
    // const filter = new FilterEntity('CG_Type', 'ENTIER', null, '=', value);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('APP_HOS_SALLE', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle', 'description')
    );
  }
  public getLaboratoires() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_LAB_LABORATOIRE', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle', 'description')
    );
  }

  public getExamen() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_LAB_EXAMEN', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle', 'ar_ref')
    );
  }

  public getSecteur() {
    // const filter = new FilterEntity('CG_Type', 'ENTIER', null, '=', value);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('APP_SECTEUR', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle', 'description')
    );
  }

  public getServiceHos() {
    // const filter = new FilterEntity('CG_Type', 'ENTIER', null, '=', value);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('APP_SERVICE', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle', 'description')
    );
  }

  public getArticleConsultation() {
    // const filter = new FilterEntity('CG_Type', 'ENTIER', null, '=', value);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_CONSULTATION', [], this.tokenStorage.getCurrentSite(),
        'id', 'arRef', 'libelle')
    );
  }
  public getCompteG(value?: string) {
    if (value) {
      const filterCgNum = new FilterEntity('CG_Num', 'CHAINE', null, 'LIKE', value);
      const filterCgInti = new FilterEntity('CG_Intitule', 'CHAINE', 'OR', 'LIKE', value);

      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_COMPTEG', [filterCgNum, filterCgInti], this.tokenStorage.getCurrentSite(),
          'CG_Num', 'CG_Classement', 'CG_Intitule')
      );
    } else {
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_COMPTEG', [], this.tokenStorage.getCurrentSite(),
          'CG_Num', 'CG_Classement', 'CG_Intitule')
      );
    }
  }
  public getCompteGByType(value: string, type: number) {
    const listFilter = [];
    const filterCgNum = new FilterEntity('CG_Num', 'CHAINE', null, 'LIKE', value);
    const filterType = new FilterEntity('CG_Type', 'ENTIER', 'AND', '=', `${type}`);
    const filterCgInti = new FilterEntity('CG_Intitule', 'CHAINE', 'OR', 'LIKE', value);
    listFilter.push(filterCgNum, filterType, filterCgInti, filterType);

    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COMPTEG', listFilter, this.tokenStorage.getCurrentSite(),
        'CG_Num', 'CG_Classement', 'CG_Intitule')
    );
  }
  public getCompteGenerauxV2(value) {
    const filter = new FilterEntity('CG_Type', 'ENTIER', null, '=', value);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COMPTEG', [filter], this.tokenStorage.getCurrentSite(),
        'CG_Num', 'CG_Classement', 'CG_Intitule')
    );
  }

  public getCompteTiers() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COMPTET', [], this.tokenStorage.getCurrentSite(),
        'CT_Num', 'CT_Intitule', 'CT_CodePostal')
    );
  }

  public getCompteTiersV2(type) {
    const filter = new FilterEntity('CT_Type', 'ENTIER', null, '=', type, null);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COMPTET', [filter], this.tokenStorage.getCurrentSite(),
        'CT_Num', 'CT_Intitule', 'CT_CodePostal')
    );
  }
  public getCompteTiers0Someil(type, sommeil?, token?) {
    const filter = new FilterEntity('CT_Type', 'ENTIER', null, '=', type, null);
    const filterSommeil = new FilterEntity('CT_Sommeil', 'ENTIER', null, '=', sommeil, null);

    let dto;
    if (token) {
      const filterToken = new FilterEntity('CT_Intitule', 'CHAINE', null, 'LIKE', token, null);
      dto = {
        entity: `F_COMPTET`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'CT_Num', label: 'CT_Intitule', filters: [filter, filterSommeil, filterToken],
        keyAlias: 'id', labelAlias: 'name',
        page: 0,
        size: 10
      }
    } else {
      dto = {
        entity: `F_COMPTET`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'CT_Num', label: 'CT_Intitule', secondLabel: 'CT_CodePostal', filters: [filter, filterSommeil],
        keyAlias: 'id', labelAlias: 'name',
        page: 0,
        size: 10
      }
      // return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      //   new FindEssentialEntity('F_COMPTET', [filter, filterSommeil], this.tokenStorage.getCurrentSite(),
      //     'CT_Num', 'CT_Intitule', 'CT_CodePostal')
      // );
    }
    return this.genericsService.postResource(environment.entityUrls.essentialDataPage,
      dto);
  }
  public getPrmTypeDoc(sens, token?) {
    const filterSens = new FilterEntity('sens', 'ENTIER', null, '=', sens, null);
    let dto;
    if (token) {
      const filterToken = new FilterEntity('libelle_document', 'CHAINE', null, 'LIKE', token, null);
      dto = {
        entity: `SYS_TYPE_DOCUMENT_TRANSFERT`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'id', label: 'libelle_document', secondLabel: 'do_type', filters: [filterSens, filterToken],
        keyAlias: 'id', labelAlias: 'name',
        page: 0,
        size: 10
      }
    } else {
      dto = {
        entity: `SYS_TYPE_DOCUMENT_TRANSFERT`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'id', label: 'libelle_document', secondLabel: 'do_type', filters: [filterSens],
        keyAlias: 'id', labelAlias: 'name',
        page: 0,
        size: 10
      }
    }
    return this.genericsService.postResource(environment.entityUrls.essentialDataPage,
      dto);
  }

  public getMotifVersement() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_MOTIF_VERSEMENT', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle', 'description')
    );
  }

  public getCompteTiersV3(type, labelTiers) {
    const filter = new FilterEntity('CT_Type', 'ENTIER', null, '=', type, null);
    const filter1 = new FilterEntity('CT_Sommeil', 'ENTIER', null, '=', '0', null);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      {
        entity: `F_COMPTET`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'CT_Num', label: labelTiers, filters: [filter, filter1],
        keyAlias: 'id', labelAlias: 'name'
      });
  }
  public getCompteTiersV3Page(type, labelTiers, keyFilter, keywordFilter) {
    const filter = new FilterEntity('CT_Type', 'ENTIER', null, '=', type, null);
    const filter1 = new FilterEntity('CT_Sommeil', 'ENTIER', null, '=', '0', null);
    let filter2;
    let filter3;
    if (keyFilter === 'Autre') {
      filter2 = new FilterEntity('CT_Num', 'CHAINE', null, 'LIKE', keywordFilter, null);
      filter3 = new FilterEntity('CT_Intitule', 'CHAINE', 'OR', 'LIKE', keywordFilter, null);
    } else {
      filter2 = new FilterEntity(keyFilter, 'CHAINE', null, 'LIKE', keywordFilter, null);
    }
    const secondLabel = 'CT_Intitule';
    let dto;
    if (labelTiers === 'Autre') {
      dto = {
        entity: `F_COMPTET`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'CT_Num', label: 'CT_Num', secondLabel, filters: [filter, filter1, filter2, filter3, filter, filter1],
        keyAlias: 'id', labelAlias: 'name',
        page: 0,
        size: 10
      }
    } else {
      dto = {
        entity: `F_COMPTET`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'CT_Num', label: labelTiers, filters: [filter, filter1, filter2],
        keyAlias: 'id', labelAlias: 'name',
        page: 0,
        size: 10
      }
    }
    return this.genericsService.postResource(environment.entityUrls.essentialDataPage,
      dto);
  }

  public getComptePatientV3Page(labelTiers, keyFilter, keywordFilter) {
    let filter2;
    let filter3;
    const secondLabel = 'noms';
    let dto;
    if (keyFilter === 'Autre') {
      filter2 = new FilterEntity('code_patient', 'CHAINE', null, 'LIKE', keywordFilter, null);
      filter3 = new FilterEntity('noms', 'CHAINE', null, 'LIKE', keywordFilter, null);
    } else {
      filter2 = new FilterEntity(keyFilter, 'CHAINE', null, 'LIKE', keywordFilter, null);
    }
    if (labelTiers === 'Autre') {
      dto = {
        entity: `APP_PATIENT`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'code_patient', label: 'code_patient', secondLabel, filters: [filter2, filter3],
        keyAlias: 'id', labelAlias: 'name',
        page: 0,
        size: 10
      }
    } else {
      dto = {
        entity: `APP_PATIENT`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'code_patient', label: labelTiers, filters: [filter2],
        keyAlias: 'id', labelAlias: 'name',
        page: 0,
        size: 10
      }
    }
    return this.genericsService.postResource(environment.entityUrls.essentialDataPage,
      dto);
  }

  public getCompteTiersV4(typeCompte, key: string, label: string) {
    const filterCG = new FilterEntity('CT_Num', 'CHAINE', null, '=', typeCompte, null);
    const filterEssential = new FindEssentialEntity('F_COMPTET', [filterCG], this.tokenStorage.getCurrentSite(), key, label);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, filterEssential);
  }

  public getCompteTiersV5(filter, key: string, label: string, secondLabel) {
    const filterEssential = new FindEssentialEntity('F_COMPTET', [filter], this.tokenStorage.getCurrentSite(), key, label, secondLabel);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, filterEssential);
  }

  public getCodeJournaux(type?: string) {
    let filter;
    if (type === 'banque') {
      filter = [new FilterEntity('JO_Type', 'CHAINE', null, '=', '2', null)];
    } else {
      filter = []
    }
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_JOURNAUX', [], this.tokenStorage.getCurrentSite(),
        'JO_NUM', 'JO_Intitule')
    );
  }

  public getCodeJournauxV2(value) {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_JOURNAUX',
        [new FilterEntity('JO_Type', 'ENTIER', null, '=', value)],
        this.tokenStorage.getCurrentSite(), 'JO_NUM', 'JO_Intitule')
    );
  }

  public getCentrale() {
    // Pour le centrale, TYPE=0
    const filter = new FilterEntity('TYPE', 'ENTIER', null, '=', '0');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('SYS_SITE', [filter], this.tokenStorage.getCurrentSite(),
        'id', 'name', 'url_adresse')
    );
  }
  public getDevises() {
    const filter = new FilterEntity('D_Intitule', 'CHAINE', null, '!=', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_DEVISE', [filter], this.tokenStorage.getCurrentSite(),
        'cbIndice', 'D_Intitule', 'D_Monnaie')
    );
  }

  public getTarif() {
    // const filter = new FilterEntity('cbIndice', 'CHAINE', null, '!=', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_CATTARIF', [], this.tokenStorage.getCurrentSite(),
        'cbIndice', 'CT_Intitule', 'CT_prixTTC')
    );
  }

  public getDepot(depot) {
    const filter = new FilterEntity('DTC_CODE_SITE', 'CHAINE', null, '=', depot);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_DEPOT', [filter], this.tokenStorage.getCurrentSite(),
        'DE_No', 'DE_Intitule', 'DE_Principal')
    );
  }

  public getPays() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_PAYS', [], this.tokenStorage.getCurrentSite(), 'PA_Code', 'PA_Intitule')
    );
  }
  public getArticle(token?: any) {
    if (token) {
      const filter = new FilterEntity('AR_Design', 'CHAINE', null, 'LIKE', token);
      const dto = {
        entity: `F_ARTICLE`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'AR_Ref', label: 'AR_Design', filters: [filter],
        page: 0,
        size: 10
      }
      return this.genericsService.postResource(environment.entityUrls.essentialDataPage, dto);
    } else {
      const dto = {
        entity: `F_ARTICLE`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'AR_Ref', label: 'AR_Design', filters: [],
        page: 0,
        size: 10
      }
      return this.genericsService.postResource(environment.entityUrls.essentialDataPage,
        dto)
    }
  }
  public getOperations(token?: any) {
    if (token) {
      const filter = new FilterEntity('libelle', 'CHAINE', null, 'LIKE', token);
      const dto = {
        entity: `SYS_OPERATION`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'id', label: 'libelle', filters: [filter],
        page: 0,
        size: 10
      }
      return this.genericsService.postResource(environment.entityUrls.essentialDataPage, dto);
    } else {
      const dto = {
        entity: `SYS_OPERATION`, idSite: this.tokenStorage.getCurrentSite(),
        key: 'id', label: 'libelle', filters: [],
        page: 0,
        size: 10
      }
      return this.genericsService.postResource(environment.entityUrls.essentialDataPage,
        dto)
    }
  }

  public getTypeAnalytique() {
    const filter = new FilterEntity('A_Intitule', 'CHAINE', null, '<>', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_ANALYTIQUE', [filter], this.tokenStorage.getCurrentSite(), 'cbIndice', 'A_Intitule')
    );
  }

  public getSectionAnalytique(type) {
    const filterCA = new FilterEntity('CA_Type', 'ENTIER', null, '=', '0');
    const filter = new FilterEntity('N_Analytique', 'ENTIER', null, '=', type);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COMPTEA', [filterCA, filter], this.tokenStorage.getCurrentSite(), 'CA_Num', 'CA_Intitule')
    );
  }
  public getCompteCollectif() {
    const filter = new FilterEntity('CG_Type', 'ENTIER', null, '=', '0');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COMPTEG', [filter], this.tokenStorage.getCurrentSite(), 'CG_Num', 'CG_Intitule', 'CG_Type')
    );
  }

  public getModelSaisie(joNum) {
    const filter = new FilterEntity('JO_NUM', 'CHAINE', null, '=', joNum);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_PIECE', [filter], this.tokenStorage.getCurrentSite(),
        'PI_No', 'PI_Intitule', 'JO_NUM')
    );
  }

  public getVariableGlobals() {
    const filter = new FilterEntity('cle', 'CHAINE', null, '=', 'DECLARATION_FOND_DE_CAISSE');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_VARIABLE_GLOBALE', [filter], this.tokenStorage.getCurrentSite(),
        'id_variable_globale', 'cle', 'valeur')
    );
  }
  public getVGTypeApp() {
    const filter = new FilterEntity('cle', 'CHAINE', null, '=', 'HOSPITALISATION_GESCOM');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_VARIABLE_GLOBALE', [filter], this.tokenStorage.getCurrentSite(),
        'id_variable_globale', 'cle', 'valeur')
    );
  }

  public getVariableGlobalsMultiCaisse() {
    const filter = new FilterEntity('cle', 'CHAINE', null, '=', 'MULTI_CAISSES');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_VARIABLE_GLOBALE', [filter], this.tokenStorage.getCurrentSite(),
        'id_variable_globale', 'cle', 'valeur')
    );
  }

  public getRoleUserSociete() {
    const filter = new FilterEntity('cle',
      'CHAINE', null, '=', 'ACTIVER_UTILISATION_ROLE_ADMIN_SOCIETE');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_VARIABLE_GLOBALE', [filter], this.tokenStorage.getCurrentSite(),
        'id_variable_globale', 'cle', 'valeur')
    );
  }

  public getVariableGlobalsParam(variable: any) {
    const filter = new FilterEntity('cle', 'CHAINE', null, '=', variable);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_VARIABLE_GLOBALE', [filter], this.tokenStorage.getCurrentSite(),
        'id_variable_globale', 'cle', 'valeur')
    );
  }

  public getPromotionsActif() {
    const filter = new FilterEntity('statut', 'CHAINE', null, '=', 'ACTIF');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('APP_PROMOTION', [filter], this.tokenStorage.getCurrentSite(),
        'id', 'intitule', 'description')
    );
  }
  public getModeReglement() {
    const filter = new FilterEntity('R_Intitule', 'CHAINE', null, '<>', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_REGLEMENT', [filter], this.tokenStorage.getCurrentSite(),
        'cbIndice', 'R_Intitule', 'R_Code')
    );
  }

  public getCollaborateurs(COAcheteur?) {
    if (COAcheteur && COAcheteur !== 'VENDEUR') {
      const filter = new FilterEntity('CO_Acheteur', 'ENTIER', null, '=', COAcheteur);
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_COLLABORATEUR', [filter], this.tokenStorage.getCurrentSite(), 'CO_No', 'CO_Nom', 'CO_Prenom')
      );
    } else if (COAcheteur && COAcheteur === 'VENDEUR') {
      const filter = new FilterEntity('CO_Vendeur', 'ENTIER', null, '=', '1');
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_COLLABORATEUR', [filter], this.tokenStorage.getCurrentSite(), 'CO_No', 'CO_Nom', 'CO_Prenom')
      );
    } else {
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_COLLABORATEUR', null, this.tokenStorage.getCurrentSite(), 'CO_No', 'CO_Nom', 'CO_Prenom')
      );
    }
  }

  public getVendeursUnic(keyword?: string) {
    const filter = new FilterEntity('CO_Vendeur', 'ENTIER', null, '=', '1');
    let AllFilter = [filter];
    if (keyword) {
      const filterTokenNom = new FilterEntity('CO_Nom', 'CHAINE', null, 'LIKE', keyword);
      const filterTokenPnom = new FilterEntity('CO_Nom', 'CHAINE', 'OR', 'LIKE', keyword);
      AllFilter = [filter, filterTokenNom, filterTokenPnom];
    }
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COLLABORATEUR', AllFilter, this.tokenStorage.getCurrentSite(), 'CO_No', 'CO_Nom', 'CO_Prenom')
    );
  }

  public getTarifsClient(keyword?: string) {
    let AllFilter = [];
    if (keyword) {
      const filterToken = new FilterEntity('CT_Intitule', 'CHAINE', null, 'LIKE', keyword);
      AllFilter = [filterToken];
    }
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_CATTARIF', AllFilter, this.tokenStorage.getCurrentSite(), 'cbMarq', 'CT_Intitule', 'CT_PrixTTC')
    );
  }

  public getAcheteurs() {
    const filter = new FilterEntity('CO_Acheteur', 'ENTIER', null, '=', '1');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COLLABORATEUR', [filter], this.tokenStorage.getCurrentSite(), 'CO_No', 'CO_Nom', 'CO_Prenom')
    );
  }

  public getAppliquerTarif() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_a_appliquer_tarif', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getSensTaxe() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_sens_taxe', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getObjectifs() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_objectif_tarif', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getConditionModeleR() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_condition_reglement ', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getCalculs() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_calcul_tarif', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getDomaines() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_domaine_tarif', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }
  public getDomainesGlossaire() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_domaine_glossaire', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getBases() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_base_tarif', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getTypeRemises() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_type_remise', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getTypeTarifs() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_type_tarif_select', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getFournisseurs() {
    const filter = new FilterEntity('CT_Type', 'ENTIER', null, '=', '1');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_COMPTET', [filter], this.tokenStorage.getCurrentSite(),
        'CT_Num', 'CT_Intitule', 'CT_CodePostal')
    );
  }

  public getFournisseursPage(token) {
    const filter = new FilterEntity('CT_Type', 'ENTIER', null, '=', '1');
    if (token) {
      const filterToken = new FilterEntity('CT_Intitule', 'CHAINE', null, 'LIKE', token);
      return this.genericsService.postResource(environment.entityUrls.essentialDataPage,
        new FindEssentialEntity('F_COMPTET', [filter, filterToken], this.tokenStorage.getCurrentSite(),
          'CT_Num', 'CT_Intitule', 'CT_CodePostal')
      );
    }
    return this.genericsService.postResource(environment.entityUrls.essentialDataPage,
      new FindEssentialEntity('F_COMPTET', [filter], this.tokenStorage.getCurrentSite(),
        'CT_Num', 'CT_Intitule', 'CT_CodePostal')
    );
  }

  public getDepotEmplacement(deNo, dpType) {
    let filter1;
    let filter2;
    if (deNo || deNo === 0) {
      filter1 = new FilterEntity('DE_No', 'ENTIER', null, '=', deNo);
      filter2 = new FilterEntity('DP_Type', 'ENTIER', null, '=', dpType);
    }
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_DEPOTEMPL', [filter1, filter2], this.tokenStorage.getCurrentSite(),
        'DP_No', 'DP_Intitule', 'DP_Type')
    );
  }

  public getDepotsBySite(codeSite, token?) {
    console.log(codeSite)
    console.log(token)
    if (codeSite) {
      const filter = new FilterEntity('dtc_code_site', 'CHAINE', null, 'LIKE', codeSite);
      if (token) {
        const filterToken = new FilterEntity('DE_Intitule', 'CHAINE', null, 'LIKE', token);
        return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
          new FindEssentialEntity('F_DEPOT', [filter, filterToken], this.tokenStorage.getCurrentSite(),
            'DE_No', 'DE_Intitule', 'DE_Principal')
        );
      } else {
        return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
          new FindEssentialEntity('F_DEPOT', [filter], this.tokenStorage.getCurrentSite(),
            'DE_No', 'DE_Intitule', 'DE_Principal')
        );
      }
    } else {
      this.getAllDepots();
    }
  }

  public getDepots() {
    const codeSite = this.tokenStorage.getCodeSite();

    if (codeSite === this.codeSite) {
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_DEPOT', null, this.tokenStorage.getCurrentSite(),
          'DE_No', 'DE_Intitule', 'DE_Principal')
      );
    } else {
      const filter = new FilterEntity('dtc_code_site', 'CHAINE', null, 'LIKE', codeSite);
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_DEPOT', [filter], this.tokenStorage.getCurrentSite(),
          'DE_No', 'DE_Intitule', 'DE_Principal')
      );
    }
  }
  public getAllDepots() {
    // const codeSite = this.tokenStorage.getCodeSite();
    //  );
    //
    //
    // if (codeSite === this.codeSite){
    //   return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
    //     new FindEssentialEntity('F_DEPOT', null, this.tokenStorage.getCurrentSite(),
    //       'DE_No', 'DE_Intitule', 'DE_Code')
    //   );
    // }else {
    //   const filter = new FilterEntity('dtc_code_site', 'CHAINE', null, 'LIKE', codeSite);
    //   return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
    //     new FindEssentialEntity('F_DEPOT', [filter], this.tokenStorage.getCurrentSite(),
    //       'DE_No', 'DE_Intitule', 'DE_Code')
    //   );
    // }
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_DEPOT', null, this.tokenStorage.getCurrentSite(),
        'DE_No', 'DE_Intitule', 'DE_Code')
    );
  }

  public getAllDepotsBySite(codeSite) {
    if (codeSite) {
      const filter = new FilterEntity('dtc_code_site', 'CHAINE', null, '=', codeSite);
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_DEPOT', [filter], this.tokenStorage.getCurrentSite(),
          'DE_No', 'DE_Intitule', 'DE_Code')
      );
    } else {
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_DEPOT', null, this.tokenStorage.getCurrentSite(),
          'DE_No', 'DE_Intitule', 'DE_Code')
      );
    }

  }
  public getNumerotation() {
    const codeSite = this.tokenStorage.getCodeSite();
    const filter = new FilterEntity('codeSite', 'CHAINE', null, '=', codeSite);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_NUMEROTATION_SITE', [filter], this.tokenStorage.getCurrentSite(),
        'id_numerotation', 'libelle', 'code')
    );
  }
  public getListEtatImprimable() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('PRM_ETAT_IMPRIMABLE', null, this.tokenStorage.getCurrentSite(),
        'id_etat_imprimable', 'libelle')
    );
  }

  public getPersonnel() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('APP_PERSONNEL', null, this.tokenStorage.getCurrentSite(),
        'code_personnel', 'noms', 'prenoms')
    );
  }

  public getService() {
    const filter = new FilterEntity('name', 'CHAINE', null, '!=', 'ADMINISTRATEUR');
    const filter2 = new FilterEntity('name', 'CHAINE', null, '!=', 'UTILISATEUR');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('AUTH_HABILITATION', [filter, filter2], this.tokenStorage.getCurrentSite(),
        'id', 'name', 'description')
    );
  }

  public getConsultationParent(codePatient, idConsultation) {
    const filter = new FilterEntity('code_patient', 'CHAINE', null, '=', codePatient);
    const filter2 = new FilterEntity('id', 'ENTIER', null, '!=', idConsultation);
    const filter3 = new FilterEntity('type_consultation', 'ENTIER', null, '=', '0');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('APP_CONSULTATION_RENDEZVOUS', [filter, filter2, filter3], this.tokenStorage.getCurrentSite(),
        'id', 'libelle', 'date_consultation')
    );
  }
  public getUserDepot() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_PROTECTIONCPTA', [], this.tokenStorage.getCurrentSite(),
        'PROT_No', 'PROT_User', 'PROT_Description')
    );
  }

  public getUnites() {
    const filter = new FilterEntity('U_Intitule', 'CHAINE', null, '!=', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_UNITE', [filter], this.tokenStorage.getCurrentSite(), 'cbMarq', 'U_Intitule')
    );
  }

  public getModeleReglement() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_MODELER', null, this.tokenStorage.getCurrentSite(), 'MR_No', 'MR_Intitule')
    );
  }

  public getArticles() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_ARTICLE', [], this.tokenStorage.getCurrentSite(), 'AR_Ref', 'AR_Design'));
  }
  public getArticleV2(sommeil, token?) {
    const filter = new FilterEntity('AR_Sommeil', 'ENTIER', null, '=', sommeil);
    let filterToken;
    if (token) {
      filterToken = new FilterEntity('AR_Design', 'CHAINE', null, 'LIKE', token);
    }
    const find = new FindEssentialEntity('F_ARTICLE',
      filterToken ? [filter, filterToken] : [filter], this.tokenStorage.getCurrentSite(), 'AR_Ref', 'AR_Design', 'AR_PrixVen');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }

  public getCaisse() {
    const filter = new FilterEntity('Etat', 'ENTIER', null, '!=', '1');
    const find = new FindEssentialEntity('F_CAISSE',
      [filter], this.tokenStorage.getCurrentSite(), 'CA_No', 'CA_Intitule', 'JO_Num');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }
  public getCaisseBis(cono) {
    const filter1 = new FilterEntity('CO_No', 'ENTIER', null, '=', cono);
    const filter = new FilterEntity('Etat', 'ENTIER', null, '!=', '1', null, 'F_CAISSE');
    const findEntity = new FindEntity('F_CAISSECAISSIER', [filter, filter1], this.tokenStorage.getCurrentSite(), 30216);
    //  this.authService.onGetEntityByFilter(environment.entityUrls.gescom, this.findEntity);
    return this.genericsService.postResource(environment.entityUrls.gescom, findEntity);

    // const filter1 = new FilterEntity('CO_No', 'ENTIER', null, '=', cono);
    //  const filter = new FilterEntity('Etat', 'ENTIER', null, '!=', '1');
    // const find = new FindEssentialEntity('F_CAISSECAISSIER',
    //  [filter, filter1], this.tokenStorage.getCurrentSite(), 'CA_No', 'CA_Intitule', 'CO_No');
    //   return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }

  public getWorkflow(libelle) {
    const filter = new FilterEntity('LIBELLE', 'CHAINE', null, 'LIKE', libelle);
    let findEntity;
    if (libelle) {
      findEntity = new FindEntity('PRM_WORKFLOW', [filter], this.tokenStorage.getCurrentSite(), 30230);
    } else {
      findEntity = new FindEntity('PRM_WORKFLOW', [], this.tokenStorage.getCurrentSite(), 30230);
    }
    return this.genericsService.postResource(environment.entityUrls.gescom, findEntity);
  }
  public getWorkflowSaufId(libelle, id) {
    const filter = new FilterEntity('LIBELLE', 'CHAINE', null, 'LIKE', libelle);
    const filterId = new FilterEntity('ID', 'ENTIER', null, '<>', id);
    let findEntity;
    if (libelle && id) {
      findEntity = new FindEntity('PRM_WORKFLOW', [filter, filterId], this.tokenStorage.getCurrentSite(), 30230);
    } else {
      findEntity = new FindEntity('PRM_WORKFLOW', [filterId], this.tokenStorage.getCurrentSite(), 30230);
    }
    return this.genericsService.postResource(environment.entityUrls.gescom, findEntity);
  }
  public getEtapeWorkflow(token, idEtape, idPrmWorkflow?) {
    const filterId = new FilterEntity('ID', 'ENTIER', null, '<>', idEtape);
    let findEntity;
    if (token && !idPrmWorkflow) {
      const filter = new FilterEntity('LIBELLE', 'CHAINE', null, 'LIKE', token);
      findEntity = new FindEntity('PRM_ETAPE_WORKFLOW', [filter, filterId], this.tokenStorage.getCurrentSite(), 30232);
    } else if (!token && idPrmWorkflow) {
      const filterIdPrmWorkflow = new FilterEntity('id_prm_workflow', 'ENTIER', null, '=', idPrmWorkflow);
      findEntity = new FindEntity('PRM_ETAPE_WORKFLOW', [filterId, filterIdPrmWorkflow], this.tokenStorage.getCurrentSite(), 30232);
    } else if (token && idPrmWorkflow) {
      const filter = new FilterEntity('LIBELLE', 'CHAINE', null, 'LIKE', token);
      const filterIdPrmWorkflow = new FilterEntity('id_prm_workflow', 'ENTIER', null, '=', idPrmWorkflow);
      findEntity = new FindEntity('PRM_ETAPE_WORKFLOW', [filterId, filterIdPrmWorkflow, filter], this.tokenStorage.getCurrentSite(), 30232);
    } else {
      findEntity = new FindEntity('PRM_ETAPE_WORKFLOW', [filterId], this.tokenStorage.getCurrentSite(), 30232);
    }
    return this.genericsService.postResource(environment.entityUrls.gescom, findEntity);

  }
  public getAllEtapeWorkflow(token) {
    let findEntity;
    if (token) {
      const filter = new FilterEntity('LIBELLE', 'CHAINE', null, 'LIKE', token);
      findEntity = new FindEntity('PRM_ETAPE_WORKFLOW', [filter], this.tokenStorage.getCurrentSite(), 30232);
    } else {
      findEntity = new FindEntity('PRM_ETAPE_WORKFLOW', [], this.tokenStorage.getCurrentSite(), 30232);
    }
    return this.genericsService.postResource(environment.entityUrls.gescom, findEntity);

  }
  public getActionWorkflow(token) {
    let findEntity;
    if (token) {
      const filter = new FilterEntity('LIBELLE', 'CHAINE', null, 'LIKE', token);
      findEntity = new FindEntity('PRM_ETAPE_WORKFLOW', [filter], this.tokenStorage.getCurrentSite(), 30232);
    } else {
      findEntity = new FindEntity('PRM_ETAPE_WORKFLOW', [], this.tokenStorage.getCurrentSite(), 30232);
    }
    return this.genericsService.postResource(environment.entityUrls.gescom, findEntity);

  }

  public getModuleApplication(token) {
    let findEssential;
    if (token) {
      const filter = new FilterEntity('nom_module', 'CHAINE', null, 'LIKE', token);
      findEssential = new FindEssentialEntity('SYS_MODULE',
        [filter], this.tokenStorage.getCurrentSite(), 'id_module', 'nom_module');
    } else {
      findEssential = new FindEssentialEntity('SYS_MODULE',
        [], this.tokenStorage.getCurrentSite(), 'id_module', 'nom_module');
    }
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, findEssential);

  }

  public getFenetreApplication(token) {
    let findEssential;
    if (token) {
      const filter = new FilterEntity('libelle_fenetre', 'CHAINE', null, 'LIKE', token);
      findEssential = new FindEssentialEntity('SYS_FENETRE',
        [filter], this.tokenStorage.getCurrentSite(), 'id_fenetre', 'libelle_fenetre', 'id_module');
    } else {
      findEssential = new FindEssentialEntity('SYS_FENETRE',
        [], this.tokenStorage.getCurrentSite(), 'id_fenetre', 'libelle_fenetre', 'id_module');
    }
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, findEssential);

  }

  public getCaisses() {
    const find = new FindEssentialEntity('F_CAISSE',
      [], this.tokenStorage.getCurrentSite(), 'CA_No', 'CA_Intitule', 'JO_Num');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }

  public getCaissesOfSite() {
    const codeSite = this.tokenStorage.getCodeSite();
    let listFilter = [];
    if (codeSite !== 'PORTAIL') {
      const filter = new FilterEntity('dtc_code_site', 'CHAINE', null, '=', codeSite);
      listFilter.push(filter);
    }
    const find = new FindEssentialEntity('F_CAISSE',
      listFilter, this.tokenStorage.getCurrentSite(), 'CA_No', 'CA_Intitule', 'JO_Num');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }

  public getCaisseByDeno(deno: any) {
    const find = new FindEssentialEntity('F_CAISSE',
      [], this.tokenStorage.getCurrentSite(), 'CA_No', 'CA_Intitule', deno);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }

  public getCaisseOuver(elt) {
    const filter1 = new FilterEntity('CO_NoCaissier', 'ENTIER', null, '=', elt);
    const filter = new FilterEntity('Etat', 'ENTIER', null, '=', '1');
    const find = new FindEssentialEntity('F_CAISSE',
      [filter, filter1], this.tokenStorage.getCurrentSite(), 'CA_No', 'CA_Intitule', 'CT_Num');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }

  public getCaissiers(idUser) {
    const filterEntity = new FilterEntity('CO_Caissier', 'ENTIER', null, '=', '1');
    const filterEntity2 = new FilterEntity('dtc_id_user', 'ENTIER', null, '=', idUser);
    const find = new FindEssentialEntity('F_COLLABORATEUR',
      [filterEntity, filterEntity2], this.tokenStorage.getCurrentSite(), 'CO_No', 'CO_Nom', 'CO_Prenom');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }
  public getConsultation(elt) {
    const filterEntity = new FilterEntity('code_patient', 'CHAINE', null, '=', elt);
    const find = new FindEssentialEntity('APP_DOSSIER_PATIENT',
      [filterEntity], this.tokenStorage.getCurrentSite(), 'cle', 'valeur', 'id');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }

  public getSociete() {
    const find = new FindEssentialEntity('P_DOSSIER',
      [], this.tokenStorage.getCurrentSite(), 'cbMarq', 'D_RaisonSoc', 'D_Adresse');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }
  public getActeMedicaux(elt?: any) {
    const filterEntity = new FilterEntity('cle', 'CHAINE', null, '=', elt);
    const find = new FindEssentialEntity('PRM_ACTES_MEDICAUX',
      [], this.tokenStorage.getCurrentSite(), 'cle', 'libelle', 'description');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData, find);
  }

  public getFamilles(token?) {
    if (token) {
      const filter = new FilterEntity('FA_Intitule', 'CHAINE', null, 'LIKE', token);
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_FAMILLE', [filter], this.tokenStorage.getCurrentSite(), 'FA_CodeFamille', 'FA_Intitule')
      );
    } else {
      return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
        new FindEssentialEntity('F_FAMILLE', [], this.tokenStorage.getCurrentSite(), 'FA_CodeFamille', 'FA_Intitule')
      );
    }
  }

  public getElementSouche(doDomaine) {
    const codeSite = this.tokenStorage.getCodeSite();
    const filter1 = new FilterEntity('S_Intitule', 'CHAINE', null, '!=', '');
    const filter2 = new FilterEntity('dtc_code_site', 'CHAINE', null, '=', codeSite);
    return this.genericsService.postResource(environment?.entityUrls.essentialData,
      {
        entity: doDomaine?.toString() === '0' ? 'P_SOUCHEVENTE' : 'P_SOUCHEACHAT', filters: [filter1, filter2], key: 'cbIndice', label: 'S_Intitule', secondLabel: 'cbIndice',
        idSite: this.tokenStorage.getCurrentSite()
      });
  }

  public getNomenclatures(arRef) {
    const filter = new FilterEntity('AR_Ref', 'CHAINE', null, '=', arRef);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_NOMENCLAT', [filter], this.tokenStorage.getCurrentSite(),
        'cbMarq', 'AR_Ref', 'NO_RefDet')
    );
  }

  public getConditionnement() {
    const filter = new FilterEntity('P_Conditionnement', 'CHAINE', null, '!=', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_CONDITIONNEMENT', [filter], this.tokenStorage.getCurrentSite(), 'cbIndice', 'P_Conditionnement')
    );
  }

  public getCatCompta(doDomaine: number, id: number) {
    const filter1 = new FilterEntity('do_domaine_id', 'ENTIER', null, '=', `${doDomaine}`);
    const filter2 = new FilterEntity('id', 'ENTIER', null, '=', `${id}`);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_catcompta', [filter1, filter2], this.tokenStorage.getCurrentSite(), 'id', 'libelle', 'do_domaine')
    );
  }

  public getModeExpedition() {
    const filter1 = new FilterEntity('E_Intitule', 'CHAINE', null, '!=', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_EXPEDITION', [filter1], this.tokenStorage.getCurrentSite(), 'cbIndice', 'E_Intitule', 'E_ValFrais')
    );
  }
  public getConditionLivraison() {
    const filter1 = new FilterEntity('C_Intitule', 'CHAINE', null, '!=', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_CONDLIVR', [filter1], this.tokenStorage.getCurrentSite(), 'cbIndice', 'C_Intitule', 'C_Mode')
    );
  }

  public getCodePostal() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_LIVRAISON', [], this.tokenStorage.getCurrentSite(), 'LI_No', 'LI_Intitule', 'LI_CodePostal')
    );
  }

  public getSoucheVente() {
    const filter1 = new FilterEntity('S_Intitule', 'CHAINE', null, '!=', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_SOUCHEVENTE', [filter1], this.tokenStorage.getCurrentSite(), 'cbIndice', 'S_Intitule', 'S_Valide')
    );
  }

  public getStatusVPL() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_status_vpl', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getClassementVPL() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_classement_vpl', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getTypeMVT() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_type_reglement', [], this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getPeriodicite() {
    const filter1 = new FilterEntity('P_Period', 'CHAINE', null, '!=', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_PERIOD', [filter1], this.tokenStorage.getCurrentSite(), 'cbIndice', 'P_Period')
    );
  }

  public getDocTransformLCC() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_choice_transform_doc_lcc', [],
        this.tokenStorage.getCurrentSite(), 'id', 'libelle')
    );
  }

  public getRessource() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_RESSOURCEPROD', [], this.tokenStorage.getCurrentSite(),
        'RP_Code', 'RP_Intitule', 'RP_Complement'));
  }

  public getIntitulesAgenda(AFichier: number) {
    const filter1 = new FilterEntity('A_Fichier', 'ENTIER', null, '=', `${AFichier}`);
    const filter2 = new FilterEntity('A_Intitule', 'CHAINE', null, '!=', '');
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('P_AGENDAS', [filter1, filter2], this.tokenStorage.getCurrentSite(),
        'cbIndice', 'A_Intitule')
    );
  }

  public getIntituleEvtOrSujet(adChamp: number) {
    const filter1 = new FilterEntity('AD_Champ', 'ENTIER', null, '=', `${adChamp}`);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_AGENDADET', [filter1], this.tokenStorage.getCurrentSite(),
        'cbMarq', 'AD_Evenem'));
  }

  public getTraitementPLC() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_pl_client', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getPrioritePLC() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_priorite_livraison', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getGenerationLivraison() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_generation_livraison', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getStatutLivraison() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_statut_livraison', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getImpressionPreparationPL() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_impression_preparation_pl', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getClassementPL() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_classement_pl', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getTypeValidation() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_type_validation_pl', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getListAuthUserStory() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('AUTH_USERS', [], this.tokenStorage.getCurrentSite(),
        'id', 'username'));
  }

  public getDocLivraisonClient() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_doc_livraison_client', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getStatutLivraisonClient() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_statut_livraison_client', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getRegroupDocClient() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_regroup_doc_client', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getClientsUnic(token?) {
    const filter = new FilterEntity('CT_Intitule', 'CHAINE', null, 'LIKE', token);
    const filter1 = new FilterEntity('CT_Type', 'ENTIER', null, '=', '0');
    const filter2 = new FilterEntity('CT_Sommeil', 'ENTIER', null, '=', '0');
    let listFilter = [];
    if (token) {
      listFilter = [filter, filter1, filter2];
    } else {
      listFilter = [filter1, filter2];
    }
    const dto = {
      entity: `F_COMPTET`, idSite: this.tokenStorage.getCurrentSite(),
      key: 'CT_Num', label: 'CT_Intitule', secondLabel: 'CT_CodePostal', filters: listFilter,
      page: 0,
      size: 10
    }
    return this.genericsService.postResource(environment.entityUrls.essentialDataPage, dto);
  }

  public getTypeReception() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_type_reception_cmd_fournisseurs', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getDestinationStockageCmdFournisseur() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_dest_stockage_cmd_fournisseurs', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getClassementCommandeFournisseurs() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_classement_cmd_fournisseurs', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getStatutLivraisonFournisseurs() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_statut_livraison_fournisseur', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getRegroupementDocumentFournisseur() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_regroupement_doc_livraison_fournisseur', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getNbEtiquetteArticleImprimer() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_nb_etiquette_article_imprimer', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getNomenclatureArticle() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_nomenclature_article', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getDataByEssential(entity) {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity(entity, [], this.tokenStorage.getCurrentSite(),
        'FA_CodeFamille', 'FA_Intitule'));
  }

  public getTarifArticleImprimer() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_tarif_article_imprimer', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getTypeInterresseAgenda() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_type_interesse_agenda', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle'));
  }

  public getPeriodeAgenda() {
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('v_dtc_periode_agenda', [], this.tokenStorage.getCurrentSite(),
        'id', 'libelle', 'icon'));
  }

  public getDocuments(doType: number, doDomaine: number) {
    const filter1 = new FilterEntity('DO_Type', 'ENTIER', null, '=', `${doType}`);
    const filter2 = new FilterEntity('DO_Domaine', 'ENTIER', null, '=', `${doDomaine}`);
    return this.genericsService.postResourceGescomV1(environment.entityUrls.essentialData,
      new FindEssentialEntity('F_DOCENTETE', [filter1, filter2], this.tokenStorage.getCurrentSite(),
        'DO_Piece', 'DO_Type', 'DO_Ref')
    );
  }

}
